import React from "react";
import "./WhatsappChat.css";

const WhatsappChat = () => {
  return (
    <>
      <div className="main">
        <a  href=" https://wa.me/919981965973?text=Thanks For Connecting With Me....😊" target="_blank">
          <img className="whatsapp_logo" src="https://static.vecteezy.com/system/resources/previews/022/101/124/original/whatsapp-logo-transparent-free-png.png" alt="whatsapp-logo" />
        </a>
      </div>
    </>
  );
};

export default WhatsappChat;
